import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Calendar, Menu, X, Clock, MapPin } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Wheelchair Transport',
    href: '/wheelchair-transport'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Service Area',
    href: '/service-area'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-85">
      {/* Top Announcement Bar - Inspired by Gozie */}
      <div className="bg-blue-600 text-white py-2 px-4 text-center text-sm font-medium hidden sm:block" data-id="element-86">
        <p data-id="element-87">
          Reliable & Compassionate Door-to-Door Service.{' '}
          <Link to="/contact" className="underline hover:text-blue-100 ml-1" data-id="element-88">
            Call (704) AMO-RIDE for affordable rates
          </Link>
        </p>
      </div>

      {/* Info Bar */}
      <div className="bg-slate-900 text-white py-3 px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-xs sm:text-sm" data-id="element-90">
          <div className="flex items-center space-x-6" data-id="element-91">
            <a href="tel:7040000000" className="flex items-center hover:text-blue-400 transition-colors" data-id="element-92">
              <Phone className="w-4 h-4 mr-2 text-blue-400" data-id="element-93" />
              (704) AMO-RIDE
            </a>
            <div className="hidden md:flex items-center" data-id="element-94">
              <Clock className="w-4 h-4 mr-2 text-blue-400" data-id="element-95" />
              24/7 Availability
            </div>
          </div>
          <div className="flex items-center" data-id="element-96">
            <div className="hidden lg:flex items-center text-blue-400 font-bold uppercase tracking-wider" data-id="element-97">
              <MapPin className="w-4 h-4 mr-2" data-id="element-98" />
              Serving Charlotte & Surrounding NC Areas
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-white shadow-md border-b border-slate-100" data-id="element-99">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
          <div className="flex justify-between items-center h-20" data-id="element-101">
            {/* Logo */}
            <Link to="/" className="flex items-center" data-id="element-102">
              <div className="text-2xl font-black tracking-tighter text-slate-900" data-id="element-103">
                AMO<span className="text-blue-600" data-id="element-104">WTS</span>
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center space-x-1" data-id="element-105">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`px-4 py-2 text-sm font-bold transition-colors rounded-md ${isActive(link.href) ? 'text-blue-600 bg-blue-50' : 'text-slate-700 hover:text-blue-600 hover:bg-slate-50'}`} data-id="element-106">
                  {link.name}
                </Link>)}
            </nav>

            {/* Action Buttons */}
            <div className="hidden lg:flex items-center space-x-3" data-id="element-107">
              <a href="tel:7040000000" className="flex items-center px-4 py-2.5 border-2 border-slate-200 rounded-lg text-sm font-bold text-slate-900 hover:border-blue-600 hover:text-blue-600 transition-all" data-id="element-108">
                <Phone className="w-4 h-4 mr-2" data-id="element-109" />
                Call Now
              </a>
              <Link to="/contact" className="flex items-center px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-200" data-id="element-110">
                <Calendar className="w-4 h-4 mr-2" data-id="element-111" />
                Book a Ride
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center" data-id="element-112">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 p-2 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-113">
                {isMobileMenuOpen ? <X size={28} data-id="element-114" /> : <Menu size={28} data-id="element-115" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-slate-100 absolute w-full left-0 shadow-2xl animate-in slide-in-from-top duration-300" data-id="element-116">
          <div className="px-4 pt-2 pb-8 space-y-1" data-id="element-117">
            {navLinks.map(link => <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`block px-4 py-4 text-lg font-bold rounded-lg ${isActive(link.href) ? 'text-blue-600 bg-blue-50' : 'text-slate-700 hover:bg-slate-50'}`} data-id="element-118">
                {link.name}
              </Link>)}
            <div className="pt-6 grid grid-cols-1 gap-3" data-id="element-119">
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="w-full bg-blue-600 text-white px-6 py-4 rounded-xl text-center font-bold text-lg shadow-lg" data-id="element-120">
                Book a Ride
              </Link>
              <a href="tel:7040000000" className="w-full border-2 border-slate-200 text-slate-900 px-6 py-4 rounded-xl text-center font-bold text-lg" data-id="element-121">
                Call (704) AMO-RIDE
              </a>
            </div>
          </div>
        </div>}
    </header>;
}